import { CountrySelect } from "@/Common/Components/Contacts/CountrySelect";
import { TextboxMaskedControl } from "@/Common/Components/Inputs/TextboxMaskedControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

interface IPhoneContactFormProps {
    phoneNumber: string;
    countryLookupId: string;
    onPhoneNumberChange: (phoneNumber: string) => void;
    onCountryLookupChange: (countryLookupId: string) => void;
}

function PhoneContactForm(props: IPhoneContactFormProps): JSX.Element {
    const { getText } = useTranslation();

    const { phoneNumber, countryLookupId, onPhoneNumberChange, onCountryLookupChange } = props;

    const validationHelper = new ValidationHelper();

    const phoneValidationRule = validationHelper.getPhoneNumberValidationRule(countryLookupId, null);

    return (
        <>
            <div className="form-group margin-md-bottom">
                <label htmlFor="contactCountry">
                    <strong>{getText("CountryLabel")}</strong>
                </label>
                <div style={{ width: "60%" }}>
                    <CountrySelect
                        dataCy="phoneContact-country"
                        onCountryChange={onCountryLookupChange}
                        initialCountryLookupId={countryLookupId}
                    />
                </div>
            </div>

            <div className="form-group margin-md-bottom">
                <label htmlFor="contactPhone">
                    <strong>{getText("PhoneLabel")}</strong>
                </label>

                <TextboxMaskedControl
                    id="contactPhone"
                    className="width-60-percent"
                    isValid={ValidationHelper.isExactMatch(phoneNumber, new RegExp(phoneValidationRule?.ValidationRegexPattern ?? "", "i"))}
                    value={phoneNumber}
                    onChangeFunction={onPhoneNumberChange}
                    mask={validationHelper.getPhoneNumberValidationRule(countryLookupId, null)?.EditMaskPattern ?? ""}
                    validationErrorMessage={phoneValidationRule?.ValidationErrorMessageLookupId
                        ? cacheStore.GetLocalizedValueByLookupId(phoneValidationRule?.ValidationErrorMessageLookupId)
                        : ""
                    }
                />
            </div>
        </>
    );
}

export { PhoneContactForm };
